<script>
import axios from 'axios'

import { authComputed } from '@/state/helpers'
import i18n from '../i18n'
import { Helper } from '@/mixin/helper'
import update from '@/mixin/update'
import NotificationIcon from './Notification/NotificationIcon.vue'
import NotificationContainer from './Notification/NotificationContainer.vue'
import { getApp, deleteApp } from 'firebase/app'
import { deleteToken, getMessaging } from 'firebase/messaging'
import { unregisterFCMServiceWorkers } from '@/helpers/unregister-service-workers'

/**
 * Nav-bar Component
 */
export default {
  components: {
    NotificationIcon,
    NotificationContainer
  },
  data() {
    return {
      languages: [
        {
          flag: require('@/assets/images/flags/us.jpg'),
          language: 'en',
          title: 'English',
        },
        {
          flag: require('@/assets/images/flags/french.jpg'),
          language: 'id',
          title: 'Bahasa',
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      myVar: 1,
      dropDownAccount: false,
      phaseOneShow: false,
    }
  },
  mixins: [Helper, update],
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale)
    this.text = this.value.title
    this.flag = this.value.flag
    const flag = this.$store.getters['identity/getFeatureFlagData']('notification')

    if (!flag) {
      console.warn('Feature flag "notification" not found')
      return
    }

  },

  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },

    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },

    initFullScreen() {
      document.body.classList.toggle('fullscreen-enable')
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen()
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen()
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    },

    setLanguage(locale, country, flag) {
      this.lan = locale
      this.text = country
      this.flag = flag
      i18n.locale = locale
    },

    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      axios.get('http://127.0.0.1:8000/api/logout').then((res) => {
        this.$router.push({
          name: 'default',
        })
      })
    },
    async logout() {
      try {
        // Make sure the fireabase app is initialized
        const app = this.getFirebaseApp('vsmsNotif')
        const messaging = getMessaging(app)

        // Attemp to delete FCM Token
        await this.deleteFCMToken(messaging)

        // Unregister FCM service workers
        await unregisterFCMServiceWorkers(navigator)

        if (app) await deleteApp(app)

        // Redirect to logout URL
        this.redirectToLogout()
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error during logout:', error)

        // Fallback redirect to logout URL in case of errors
        this.redirectToLogout()
      }
    },

    async deleteFCMToken(messaging) {
      try {
        const result = await deleteToken(messaging)
        if (!result) {
          // eslint-disable-next-line no-console
          console.warn('Failed to delete registration token')
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error deleting FCM token:', error)
      }
    },

    getFirebaseApp(appName) {
      try {
        return getApp(appName)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Firebase app '${appName}' is not initialized.`, error)
        throw error
      }
    },

    redirectToLogout() {
      setTimeout(() => {
        location.href = `${process.env.BASE_URL}logout`
      }, 500)
    },

    toggleAccount() {
      this.dropDownAccount = !this.dropDownAccount
    },
  },

  computed: {
    ...authComputed,
    isNotificationActive() {
      return this.getFeatureFlagData('notification')?.value && this.hasAccessAll(['sms-notification:read'])
    },
  },
}
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/mceasy-small.png" alt height="16" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/mceasy.png" alt height="17" />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/mceasy-small.png" alt height="16" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/mceasy.png" alt height="17" />
            </span>
          </router-link>
        </div>

        <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu">
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <div class="mc-update">
          <!-- v-if="updateExists" -->
          <b-button variant="warning" @click="refreshApp" v-if="updateExists"><i
              class="mc-fa icon-outline_alert-triangle"></i> Update</b-button>
        </div>
      </div>

      <!-- App Search-->
      <!-- <form class="app-search d-none d-lg-block">
        <div class="position-relative">
          <input type="text" class="form-control" placeholder="Search..." />
          <span class="bx bx-search-alt"></span>
        </div>
      </form> -->

      <div class="d-flex">
        <b-dropdown class="d-inline-block d-lg-none ms-2" variant="black" menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon" right v-if="phaseOneShow">
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username" />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <b-dropdown variant="white" right toggle-class="header-item" class="mc-header-lang" v-if="phaseOneShow">
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            {{ text }}
          </template>
          <b-dropdown-item class="notify-item" v-for="(entry, i) in languages" :key="`Lang${i}`" :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)" :class="{ active: lan === entry.language }">
            <img :src="`${entry.flag}`" alt="user-image" class="me-1" height="12" />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <!-- <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div> -->

        <NotificationIcon v-if="isNotificationActive" />
        <NotificationContainer v-if="isNotificationActive" ref="notificationContainer" />
        <!-- v-if="updateExists" -->
        <b-button v-if="updateExists" variant="outline-info" @click="refreshApp">Update</b-button>

        <div :class="{
          'dropdown b-dropdown btn-group': dropDownAccount === false,
          'dropdown b-dropdown btn-group show': dropDownAccount === true,
        }">
          <button type="button" class="btn dropdown-toggle btn-black header-item">
            <div @click="toggleAccount">
              <span class="d-none d-xl-inline-block me-4">
                <div>{{ getUserName() }}</div>
              </span>
              <img class="rounded-circle header-profile-user" :src="getUserPhoto()" alt="Header Avatar" />
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </div>
          </button>
          <ul role="menu" :class="{
            'dropdown-menu dropdown-menu-end dropdown-menu-right': dropDownAccount === false,
            'dropdown-menu dropdown-menu-end dropdown-menu-right show': dropDownAccount === true,
          }">
            <a class="dropdown-item" @click="logout"><i class="icon-outline_log-out font-size-16 align-middle me-1"></i>
              {{ $t('navbar.dropdown.user.list.logout') }}
            </a>
          </ul>
        </div>

        <!-- <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div> -->
      </div>
    </div>
  </header>
</template>
